import { create } from 'zustand';

export type Theme = 'light' | 'dark' | 'system';
const KEY = 'bp-theme';

function read(): Theme {
  try {
    const v = localStorage.getItem(KEY);
    return v === 'light' || v === 'dark' || v === 'system' ? v : 'light';
  } catch {
    return 'light';
  }
}

export const prefersDark = () => typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches;
export const resolveTheme = (t: Theme): 'light' | 'dark' => (t === 'system' ? (prefersDark() ? 'dark' : 'light') : t);

interface ThemeState {
  theme: Theme;
  setTheme: (t: Theme) => void;
}

/** Preferência de tema do usuário (guardada só neste navegador). */
export const useTheme = create<ThemeState>((set) => ({
  theme: read(),
  setTheme: (theme) => {
    try {
      localStorage.setItem(KEY, theme);
    } catch {
      /* navegação privada: vale só nesta sessão */
    }
    set({ theme });
  },
}));

/** Aplica o tema no <html>. Só a área logada chama isto; site público e landing mantêm as próprias cores. */
export function applyTheme(theme: Theme) {
  const dark = resolveTheme(theme) === 'dark';
  document.documentElement.classList.toggle('dark', dark);
}

export function clearTheme() {
  document.documentElement.classList.remove('dark');
}
